import * as React from 'react';

import { ContentCard } from '@rematter/ui-web';

import { ScaleFormState } from '../../../_state/scaleForm.state';
import { ScaleDetailRecord } from '../../../types/sidecar';

import { ScaleFormFields } from './ScaleFormFields';
import { ScaleFormFooterActions } from './ScaleFormFooterActions';

type Props = {
  scale?: ScaleDetailRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: ScaleFormState) => void;
  isSaving?: boolean;
};

export const ScaleTabInfo: React.FC<Props> = ({
  scale,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@ScaleTabInfo flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <ScaleFormFields scale={scale} />
      <ScaleFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
